import * as React from 'react';

interface DeleteModalHeaderProps {
  icon: string;
  title: string;
  subtitle: string;
  description: string;
}

export const DeleteModalHeader: React.FC<DeleteModalHeaderProps> = ({
  icon,
  title,
  subtitle,
  description,
}) => (
  <div className='mb-6'>
    <div className='mb-2 flex items-center gap-3'>
      {/*
           Icon Container
           - Adjusted to fit 36x36 icon comfortably.
           - w-12 h-12 (48px) provides a bit of padding for a 36px icon.
        */}
      <div className='flex size-9 shrink-0 items-center justify-center rounded-10 bg-red-600 text-white md:size-12'>
        {/* Icon Size: 36x36 */}
        <img src={icon} alt='' className='size-4 brightness-0 invert md:size-6' />
      </div>
      {/*
           Header Styles
           - Font: Inter V (font-sans)
           - Weight: 700 (font-bold)
           - Size: 24px
           - Line-height: 27px
           - Color: #1A1036 (text-brand-800)
        */}
      <h2 className='font-sans text-24 font-bold leading-27 text-brand-800'>{title}</h2>
    </div>
    {/*
         Subtitle Styles
         - Font: Inter V
         - Weight: 700
         - Size: 16px
         - Line-height: 20px
      */}
    <p className='mb-1 font-sans text-16 font-bold leading-20 text-red-700'>{subtitle}</p>
    <p className='font-sans text-16 font-normal text-gray-600'>{description}</p>
  </div>
);
